import { TabView, TabPanel } from 'primereact/tabview';
import React, { useContext, useEffect, useState } from 'react';
import styled from "styled-components";
import { ToastContext } from '../../services/contexts/toast-context';
import { useGetFullPortfolio, useUpdateProfile } from '../../services/api/users-api';
import { useUpdateEducations, useUpdateExperiences, useUpdateProjects, useUpdateCertifications, useUpdateSkills } from "../../services/api/portfolio-api";
import ProfileForm from '../edit-profile/form/components/profile';
import Education from '../edit-profile/form/components/educations';
import Experience from '../edit-profile/form/components/experiences';
import Skills from '../edit-profile/form/components/skills';
import Projects from '../edit-profile/form/components/projects';
import Certifications from '../edit-profile/form/components/certifications';
import Loading from '../../components/loading';

const CustomTabView = styled(TabView)`
  .p-tabview .p-tabview-nav {
    border: 0px !important;
  }
  .p-tabview-nav {
    gap: 6px;
    border: 0px !important;
    margin: 0px;
  }
`;

export default function EditProfile() {
  const [profile, setProfile] = useState({});
  const toastRef = useContext(ToastContext);

  const { data: fetchedPortfolio, isLoading: isLoadingPortfolio, error: fetchPortfolioError } = useGetFullPortfolio();

  const { mutate: updateProfile, isPending: isUpdatingProfile } = useUpdateProfile();
  const { mutate: updateEducations, isPending: isUpdatingEducations } = useUpdateEducations();
  const { mutate: updateExperiences, isPending: isUpdatingExperiences } = useUpdateExperiences();
  const { mutate: updateProjects, isPending: isUpdatingProjects } = useUpdateProjects();
  const { mutate: updateCertifications, isPending: isUpdatingCertifications } = useUpdateCertifications();
  const { mutate: updateSkills, isPending: isUpdatingSkills } = useUpdateSkills();

  useEffect(() => {
    if (fetchedPortfolio) {
      setProfile(fetchedPortfolio);
    }
  }, [fetchedPortfolio]);

  const handleSave = (mutation, field, successMessage) => (data) => {
    mutation(data, {
      onSuccess: () => {
        if (field) {
          setProfile(prev => ({
            ...prev,
            [field]: field === 'profile'
              ? { ...prev[field], ...data }
              : data,
          }));
        }
        toastRef.current.show({ severity: 'success', summary: 'Success', detail: successMessage, life: 3000 });
      },
      onError: (error) => {
        toastRef.current.show({ severity: 'error', summary: 'Error', detail: JSON.stringify(error.response?.data || error.message), life: 3000 });
      },
    });
  };

  const onEditProfile = (data) => {
    handleSave(updateProfile, 'profile', 'Profile updated')(data);
  };
  const onEditEducations = (data) => {
    updateEducations(data, {
      onSuccess: () => {
        setProfile(prev => ({ ...prev, educations: data.items }));
        toastRef.current.show({ severity: 'success', summary: 'Success', detail: 'Educations updated', life: 3000 });
      },
      onError: (error) => {
        toastRef.current.show({ severity: 'error', summary: 'Error', detail: JSON.stringify(error.response?.data || error.message), life: 3000 });
      },
    });
  };
  const onEditExperience = (data) => {
    updateExperiences(data, {
      onSuccess: () => {
        toastRef.current.show({ severity: 'success', summary: 'Success', detail: 'Experiences updated', life: 3000 });
      },
      onError: (error) => {
        toastRef.current.show({ severity: 'error', summary: 'Error', detail: JSON.stringify(error.response?.data || error.message), life: 3000 });
      },
    });
  };
  const onEditProjects = handleSave(updateProjects, 'projects', 'Projects updated');
  const onEditCertifications = handleSave(updateCertifications, 'certifications', 'Certifications updated');
  const onEditSkills = handleSave(updateSkills, 'skills', 'Skills updated');

  if (isLoadingPortfolio) return <Loading text='Loading Portfolio' />;
  if (fetchPortfolioError) return <div>Error loading portfolio: {fetchPortfolioError.message}</div>;

  return (
    <div>
      <h1>Profile Information</h1>
      <CustomTabView className='ml-1'>
        <TabPanel header="Profile">
          <ProfileForm
            loading={isUpdatingProfile}
            onSave={onEditProfile}
            dbData={profile.profile}
            editMode
          />
        </TabPanel>

        <TabPanel header="Educations">
          <Education
            loading={isUpdatingEducations}
            onSave={onEditEducations}
            dbData={profile.educations}
          />
        </TabPanel>

        <TabPanel header="Experience">
          <Experience
            loading={isUpdatingExperiences}
            onSave={onEditExperience}
            dbData={profile.experiences}
          />
        </TabPanel>

        <TabPanel header="Projects">
          <Projects
            loading={isUpdatingProjects}
            onSave={onEditProjects}
            dbData={profile.projects}
          />
        </TabPanel>

        <TabPanel header="Certifications">
          <Certifications
            loading={isUpdatingCertifications}
            onSave={onEditCertifications}
            dbData={profile.certifications}
          />
        </TabPanel>

        <TabPanel header="Skills">
          <Skills
            loading={isUpdatingSkills}
            onSave={onEditSkills}
            dbData={profile.skills}
          />
        </TabPanel>
      </CustomTabView>
    </div>
  );
}



